<div *ngIf="messageData.tip === 'alert'" class="container-fluid messageModal">
  <div class="row">
    <div class="col-12 py-2">
      <button class="c-p font-weight-bold closePosition0 close close-btn" (click)="close()">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div class="col-12 text-center mb-4 comfortaa">
      <p class="text-center" *ngIf="messageData.ContentType === 'success'">
        <i class="fas fa-check icon-borders bg-success-icon text-white"></i>
      </p>
      <p class="text-center" *ngIf="messageData.ContentType === 'fail'">
        <i class="fas fa-times icon-borders bg-danger-icon text-white"></i>
      </p>
      <ng-container *ngIf="messageData?.ErrorInfo?.length > 0">
        <div class="text-left">
          <ul class="font-weight-lighter">
            <li style="color:#530505" *ngFor="let error of messageData?.ErrorInfo">{{ error?.couponData?.bet |
              bettingType: error?.couponData?.Country | translate | capitalizeFirst }}{{': '}}{{ error?.message |
              translate }}
            </li>
          </ul>
        </div>
      </ng-container>
      <p class="font-11 font-weight-lighter my-4" *ngIf="!(messageData?.ErrorInfo?.length > 0)">{{ messageData.Content
        }}
      </p>
      <button class="btn btn-yellow px-5 font-weight-bold" (click)="close()" mat-dialog-close>
        {{ "GENERAL.CLOSE" | translate }}
      </button>
    </div>
  </div>
</div>



<!-- <div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="d-flex align-items-baseline px-4 py-3">
        <i class="fas fa-{{ design.icon }} icon-borders bg-{{ design.color }} text-white"></i>
        <div class="ml-3">
          <h4 class="font-weight-bold c-dark-text mb-0">{{ title }}</h4>
          <p class="c-dark-text-80">{{ content }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="form-row p-3 justify-content-end body-color-bg w-100">
    <div class="col-6 col-md-4">
      <button class="btn btn-md btn-block font-weight-bold py-1 mat-stroked-button mat-dialog-close"
        (click)="close('cancel')" *ngIf="cancelButtonState">
        CANCEL
      </button>
    </div>
    <div class="col-6 col-md-4">
      <button class="btn btn-{{design.color}} btn-md btn-block text-white font-weight-bold py-1 h-100"
        (click)="close('ok')">
        OKEY
      </button>
    </div>
  </div>
</div> -->